import React, {useState} from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import PinDrop from "@material-ui/icons/PinDrop"
import Home from "@material-ui/icons/Home"
import DirectionsCar from '@material-ui/icons/DirectionsCar'
import {Button} from "reactstrap";
import TicketProgressDisplay from "components/Parts/TicketProgressDisplay";
import {Call_Geocode_API} from "../../constants/Utilities";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";

/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */


function requestCoords(user) {
	/*let requestModel = new API.BuildClass(Types.Geo_Coords._name, API.RequestType.CREATE);
	requestModel.object.user = user;
	requestModel.submit(null, "PUT_DISPATCHER", true);*/
	//TODO when we actually have live geo data this can be reenabled to force an asap gps grab eventually
}

async function grabProgress(user) {
	let requestModel = new API.BuildClass(Types.Tickets_Information._name, API.RequestType.READ);
	requestModel.filter = {
		'fe': user
	}
	return await requestModel.submit(null, 'GET_PROGRESS', true);
}


const PinLocation = ({text, pkey, icon}) => {
	const [hovered, setHovered] = useState(false);
	const [progress, setProgress] = useState(null);

	return (
		<div style={{textAlign: 'center', width: '40px'}} onClick={() => {
			requestCoords(pkey)
		}} onMouseEnter={() => {
			if (icon.length !== 2) {
				grabProgress(pkey).then((data) => {
					setProgress(data.progress)
					setHovered(true)
				})
			}
		}} onMouseLeave={() => {
			if (icon.length !== 2) {
				setHovered(false)
				setProgress(null)
				setTimeout(() => setHovered(false), 100)
			}
		}}>
			{hovered && progress && <div style={{width: '400px', height: '70px', position: 'relative', left: '-190px', backgroundColor: 'white', zIndex: 999}}>
				<TicketProgressDisplay
					progress={progress}
					titleSize="17px"
					barFontSize="18px"
				/>
			</div>}
			{icon[0]}
			<span style={{fontSize: '10px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};


const CustomerPinLocation = ({text}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', fontSize: '20px'}}>
			<PinDrop fontSize={'small'}/><br/>
			<span style={{fontSize: '18px', lineHeight: '20px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};

export default class FELocationMap extends Framework.Components.Collection {
	constructor(props) {
		super(props, Types.Users._name);

		this.state.items = [];
		this.state.key = 0;

		this.state.name = '';

		this.state.customerPin = null;

		this.state.users = null;
		this.state.region = {
			pkey: 1,
			name: "Phoenix (602, 480, 623)",
			latitude: "33.4484000",
			longitude: "-112.0740000",
		};

		this.state.defaultCenter = {
			lat: 33.44838,
			lng: -112.07404
		};
		this.getCoords().then()
		this.getRegions().then()
		this.getFes().then()
		this.refreshInterval = setInterval(async () => {
			let pkeyModel = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
			pkeyModel.filter = {
				'filterRegion': this.state.region.pkey
			}
			let functioning = await pkeyModel.submit(null, 'GET_GEO_LOCATION_MAP');

			functioning.items.map(async (item, i) =>  {
				if (!functioning.items[i]['latitude'] || !functioning.items[i]['longitude']) {
					functioning.items[i]['homeLatLong'] = await this.convertAddress([item.street_1, item.city, item.state, item.zip, item.pkey])}
			});

			this.setState({items: functioning.items})
		}, 300000);
	}

	componentWillUnmount() {
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval);
			this.refreshInterval = null;
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.customerPin !== this.props.customerPin) {
			this.setState({customerPin: this.props.customerPin})
		}
	}

	

	apiIsLoaded = (map, maps) => {
		this.state.map = map;
		this.state.maps = maps;
	};

	getCoords = async () => {
		let pkeyModel = new API.BuildClass(Types.Users._name, API.RequestType.READ_ALL);
		pkeyModel.filter = {
			'filterRegion': this.state.region.pkey
		}
		let functioning = await pkeyModel.submit(null, 'GET_GEO_LOCATION_MAP');

		functioning.items.map(async (item, i) =>  {
			if (!functioning.items[i]['latitude'] || !functioning.items[i]['longitude']) {
				functioning.items[i]['homeLatLong'] = await this.convertAddress([item.street_1, item.city, item.state, item.zip, item.pkey])}
			});

		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(this.state.region.latitude, this.state.region.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
			this.state.map.setZoom(9)
		}

		setTimeout(() => {
			this.setState({
				defaultCenter: {
					lat: this.state.region.latitude,
					lng: this.state.region.longitude
				},
				items: functioning.items
			})
		}, 1500) //timeout here is to guarantee the pins are ready to be rendered

		return functioning.items;
	}

	convertAddress = async (location) => {
		if (location[0] && location[1] && location[2] && location[3]) {
			const address = (location[0] + "+" + location[1] + "+" + location[2] + "+" + location[3]).replaceAll("#", "%23");
			const response = await Call_Geocode_API(address);
			if (!response || !response?.latitude) {
				API.Toast.error(`Error getting geocoords for this address ${address}.`, {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 2000
				});
				return null;
			}
			let userModel = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
			userModel.object.user = location[4];
			userModel.object.latitude = response.latitude;
			userModel.object.longitude = response.longitude;
			userModel.submit(null, "POST_COORDS", true);
			return response;
		}
		return null;
	};

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions
			});
		} catch (error) {
		}
	}

	getFes = async () => {
		let femodel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_CALENDAR_RESOURCES';
		femodel.limit = 5000;
		try {
			femodel.filter = {
				'filterRegions': this.state.region.pkey
			}
			this.fes = await femodel.submit(null, this.read);
			this.fes = Object.keys(this.fes).map((key) => this.fes[key]);
			this.setState({fes: this.fes[3], selectedFe: null})
		} catch (error) {
			console.log(error, 'error')
		}
	}

	panToFE = () => {
		this.props.setSelectedFe(this.state.selectedFe.currentTicket ?? null);
		if (this.state.selectedFe.currentCoords[0]) {
			const latLng = new this.state.maps.LatLng(this.state.selectedFe.currentCoords[0], this.state.selectedFe.currentCoords[1]); // Makes a latlng
			this.state.map.panTo(latLng);
		} else {
			const latLng = new this.state.maps.LatLng(this.state.selectedFe.latitude ?? this.state.selectedFe.homeLatLong.latitude, this.state.selectedFe.longitude ?? this.state.selectedFe.homeLatLong.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
		}
		this.state.map.setZoom(12)
	}

	refreshPage = () => {
		this.getCoords().then();
	};

	render() {
		let zoom = 9;
		let extras = {};

		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div>
						<div className={"table-bar"}>
							<div className={'row'}>
								<div className={'col'}>
									<Select
										key={this.state.regions}
										placeholder={"Region Select"}
										value={{value: this.state.region.pkey, label: this.state.region.name}}
										onChange={(value) => {
											this.setState({region: this.state.regions.find((region) => region.pkey === value.value)}, async () => {
												this.getFes().then(await this.getCoords())
											})
										}}
										options={this.state.regions?.map(region => {
											return (
												{value: region.pkey, label: region.name}
											)
										})}
										styles={{control: styles => ({...styles, lineHeight: '30px'})}}
									/>
								</div>
								<div className={'col'}>
									<Select
										key={this.state.fes + this.state.items}
										placeholder={"Pan To FE"}
										value={this.state.selectedFe ? {
											value: this.state.selectedFe.pkey,
											label: this.state.selectedFe.name_first + " " + this.state.selectedFe.name_last
										} : {value: null, label: "Select a FE to pan to..."}}
										onChange={(value) => {
											this.setState({selectedFe: this.state.items.find((fe) => fe.pkey === value.value)}, () => {
												this.panToFE()
											})
										}}
										options={this.state.fes?.filter((fe) => {
											if (!this.state.items) {
												return true
											}
											let currentFe = this.state.items.find(item => item.pkey === fe.resourceId)
											if (currentFe) {
												if (currentFe.currentCoords[0] || currentFe.homeLatLong?.latitude || currentFe.latitude) {
													return true
												}
											} else {
												return false
											}
										}).map(fe => {
											return ({value: fe.resourceId, label: fe.resourceTitle})
										})}
										styles={{control: styles => ({...styles, lineHeight: '30px'})}}
									/>
								</div>
								<div className={'col-1 d-flex justify-content-end align-items-end'}>
									<Button onClick={async () => {
										await this.refreshPage();
									}} size={"sm"} color="primary" >
										<i className="fa fa-users"/>&nbsp;Refresh Data
									</Button>
								</div>
							</div>
						</div>
						<div style={{height: '78vh', width: '100%'}}>
							<GoogleMapReact
								bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
								defaultCenter={object.defaultCenter}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
								ref={(ref) => {
									this.mapRef = ref;
								}}
								{...extras}
							>
								{object.customerPin && <CustomerPinLocation
									zoom={zoom}
									lat={object.customerPin.lat ?? null}
									lng={object.customerPin.long ?? null}
									text={"Customer"}
								/>

								}
								{object.items && object.items.map(
									(item, i) => {
										if (!item.currentCoords || !item.currentCoords[0]) {
											if ((!item.homeLatLong || !item.homeLatLong?.latitude) && !item.latitude) {
												return null
											} else {
												return (
													<PinLocation
														key={i}
														zoom={zoom}
														text={item.name_first + " " + item.name_last}
														pkey={item.pkey}
														icon={[<Home color={'primary'} fontSize={'small'}/>, 'home']}
														lat={item.latitude ?? item.homeLatLong.latitude}
														lng={item.longitude ?? item.homeLatLong.longitude}
													/>
												)
											}
										} else {
											return (
												<PinLocation
													key={i}
													zoom={zoom}
													lat={item.currentCoords[0]}
													lng={item.currentCoords[1]}
													text={item.name_first + " " + item.name_last}
													pkey={item.pkey}
													icon={[<DirectionsCar fontSize={'small'} color={item.currentStatus === 'Off site' ? 'primary' : item.currentStatus === 'On site' ? 'error' : 'secondary'}/>]}
												/>
											)
										}
									}
								)}
							</GoogleMapReact>
						</div>

						<Framework.Elements.LoadingSpinner isLoading={object.loading}/>
					</div>
				</CardContent>
			</Card>
		)
	}
}
